import { IonCard, IonCardContent, IonGrid, IonIcon } from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router";
import DataTable, { createTheme } from "react-data-table-component";
import {
  collection,
  getDocs,
  query,
  limit,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { db } from "../firebaseConfig";
import { useAuth } from "../pages/auth/AuthContext";
import { useDispatch } from "react-redux";
import { setDashboardData } from "../redux/actions";

const DeviceListTable: React.FC = () => {
  let history = useHistory();
  const { authInfo } = useAuth()!;
  const [dataReceived, setDataReceived] = useState<any>([]);
  const dispatch = useDispatch();
  let unsubscribe: any;
  const mountedRef = useRef(true);
  const columns = [
    {
      name: "MAC ID",
      selector: (row: any) => row.mac,
      sortable: true,
      minWidth: "130px",
    },
    {
      name: "SOC (%)",
      selector: (row: any) => row.soc,
      sortable: true,
      right: true,
    },
    {
      name: "SOH (%)",
      selector: (row: any) => row.soh,
      sortable: true,
      right: true,
    },
    {
      name: "Faults",
      selector: (row: any) => row.fault,
      sortable: true,
      right: true,
    },
    {
      name: "Warning",
      // selector: (row: any) => row.warning,

      cell: (row: any) => 0, // TBD - to get back on deciphering
      // row.warning > 0 ? <IonIcon icon={warningOutline} color="lite" /> : 0,
      sortable: true,
      right: true,
    },
    {
      name: "Voltage (V)",
      selector: (row: any) => row.packVoltage,
      sortable: true,
      right: true,
      minWidth: "110px",
    },
    // {
    //   name: "Capacity",
    //   selector: (row: any) => row.availableCap,
    //   sortable: true,
    //   right: true,
    // },
    {
      name: "Status",
      selector: (row: any) => row.currentState,
      sortable: true,
      right: true,
    },
    {
      name: "Timestamp",
      selector: (row: any) => formatTimeStamp(row.timeStamp),
      sortable: true,
      minWidth: "120px",
      wrap: true,
    },
    {
      name: "Action",
      cell: (row: any) => (
        <button onClick={() => gotoDeviceDetailsPage(row)}>Details</button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  const formatTimeStamp = (ts: any) => {
    return new Date(ts).toLocaleString();
  };
  const gotoDeviceDetailsPage = (row: any) => {
    // console.log("clicked: " + JSON.stringify(row));
    history.push({
      pathname: "/page/Devices/DeviceDetails",
      search: "?query=" + row.mac,
      state: row,
    });
  };
  useEffect(() => {
    // console.log("Connecting to Firestore!");
    if (mountedRef.current) {
      (async () => {
        let authObj: any = authInfo.userMetadata;
        // let allowedDevicesCollections: any = authObj.allowedDevicesCollections[0];
        let subCollection = authObj.admin ? "allDevices" : "companyXdevices";
        // let subCollection = authObj.admin ? "allDevices" : "companyXdevices";
        const querySnapshot = await getDocs(collection(db, subCollection));
        let allDevices: any = [];
        querySnapshot.forEach((doc) => {
          allDevices.push(doc.data().mac);
        });

        let result: any = [];
        const devicesMap = new Map();
        for (let device of allDevices) {
          unsubscribe = await onSnapshot(
            query(
              collection(db, "teltonikaConnector/" + device + "/telemetry/"),
              orderBy("timeStamp", "desc"),
              limit(1)
            ),
            (querySnapshot) => {
              result = [];
              querySnapshot.forEach((doc) => {
                // doc.data() is never undefined for query doc snapshots
                console.log(doc.id, " => ", JSON.stringify(doc.data()));
                devicesMap.set(doc.data().mac, doc.data());
                devicesMap.forEach(function (value, key) {
                  result.push(value);
                });
                if (mountedRef.current) {
                  setDataReceived([...dataReceived, ...result]);
                  dispatch(setDashboardData(result));
                }
              });
            }
          );
        }
      })();
    }
    return () => {
      console.log("cleanup before: " + mountedRef.current);
      unsubscribe = null;
      mountedRef.current = false;
      console.log("cleanup after: " + mountedRef.current);
    };
  }, []);

  createTheme("customTheme", {
    text: {
      primary: "secondary",
    },
    background: {
      default: "light",
    },
    context: {
      background: "light",
      text: "secondary",
    },
  });

  return (
    <IonGrid>
      <IonCard color="light">
        <IonCardContent>
          <DataTable
            title="List of Devices"
            columns={columns}
            data={dataReceived}
            pagination
            highlightOnHover
            pointerOnHover
            theme="customTheme"
          />
        </IonCardContent>
      </IonCard>
    </IonGrid>
  );
};

export default DeviceListTable;
